import { cn } from '../lib/cn';

export interface IMarkers {
  origin?: string;
  generation?: number;
  transformLoggedError?: boolean;
  bookmarked?: boolean;
  authResult?: string | null;
}

export const Markers = ({
  origin,
  generation,
  transformLoggedError,
  bookmarked,
  authResult,
  className,
}: IMarkers & { className?: string }) => {
  const marks: { key: string; glyph: string; title: string }[] = [];

  // Only accept_and_flag lets a failed check become an event, so this is the whole "mark".
  if (authResult === 'failed') {
    marks.push({
      key: 'unverified',
      glyph: 'unverified',
      title: 'The sender check failed; this source keeps and delivers such requests anyway',
    });
  }

  if (origin === 'replay' && (generation ?? 1) >= 2) {
    marks.push({
      key: 'replay',
      glyph: `↻${generation}`,
      title: `Replayed, generation ${generation}`,
    });
  }
  if (origin === 'recover') {
    marks.push({ key: 'recover', glyph: '⤴', title: 'Recovered: re-sent through its flow' });
  }
  if (transformLoggedError) {
    marks.push({
      key: 'transform',
      glyph: '⚠',
      title: 'Delivered, but the transform wrote to console.error',
    });
  }
  if (bookmarked) {
    marks.push({ key: 'bookmark', glyph: '★', title: 'Saved as a named fixture' });
  }

  if (marks.length === 0) return null;

  return (
    <span
      className={cn('inline-flex items-center gap-2 font-mono text-meta text-muted', className)}
    >
      {marks.map((mark) => (
        <span key={mark.key} title={mark.title}>
          {mark.glyph}
        </span>
      ))}
    </span>
  );
};
